import { CustomReportFileStatusEnum } from "@c2b/muven-commons";

interface ReportFileInfo {
	message: string;
	errorMessage: string;
}

export class ReportFileModel {
	id?: number = undefined;
	idCustomReport?: number = undefined;
	createdAt: Date|string;
	expirationAt: Date|string;
	filename: string = '';
	url: string|null = '';
	status: CustomReportFileStatusEnum = CustomReportFileStatusEnum.Awaiting;
	info: ReportFileInfo|null = null;

	constructor(r?:Partial<ReportFileModel>) {
		Object.assign(this, r)
	}

	getStatusDescription():string {
		if (this.isStatusAwaiting()) {
			return 'Aguardando'
		}

		if (this.isStatusError()) {
			return 'Com erro'
		}

		if (this.isStatusProcessed()) {
			return 'Processado'
		}

		return ''
	}

	isStatusAwaiting():boolean {
		return this.status === CustomReportFileStatusEnum.Awaiting;
	}
	
	isStatusProcessed():boolean {
		return this.status === CustomReportFileStatusEnum.Processed;		
	}

	isStatusError():boolean {		
		return this.status === CustomReportFileStatusEnum.Error;
	}
}
